import React, { useState, ReactElement } from 'react';

import appThemeMain from '../../personas/mainPersona/theme';
import { appThemeMain as verintTheme } from '../../personas/examples/verintTheme';
import { appThemeMain as rainbowTheme } from '../../personas/examples/ColorExamples/rainbow';
import { appThemeMain as badContrastTheme } from '../../personas/examples/ColorExamples/badContrast';
import { appThemeMain as blackAndWhiteTheme } from '../../personas/examples/ColorExamples/blackAndWhite';
import { appThemeMain as shadesTheme } from '../../personas/examples/ColorExamples/shades';
import { appThemeMain as brushScriptTheme } from '../../personas/examples/TypographyExamples/brushScript';
import { appThemeMain as CourierNewSriptTheme } from '../../personas/examples/TypographyExamples/courierNewScript';
import { appThemeMain as adjustedTypeComfortableTheme } from '../../personas/examples/TypographyExamples/adjustedTypeSpaced';
import { appThemeMain as adjustedTypeCompressionTheme } from '../../personas/examples/TypographyExamples/adjustedTypeCompression';
import { appThemeMain as timesNewRomanScriptTheme } from '../../personas/examples/TypographyExamples/timesNewRomanScript';
import { appThemeMain as customShapeTheme } from '../../personas/examples/ShapeExamples/customShapes';
import { appThemeMain as everythingIsRoundedTheme } from '../../personas/examples/ShapeExamples/everythingIsRounded';
import { appThemeMain as everythingIsSharpTheme } from '../../personas/examples/ShapeExamples/everythingIsSharp';

import { FormControl, InputLabel, NativeSelect, ThemeOptions } from '@material-ui/core';
import { AlmeTheme } from '../../models/AlmeTheme';

interface ThemeSelectorThemeData {
    lightTheme: ThemeOptions;
    darkTheme: ThemeOptions;
    name: string;
}

const appThemes: ThemeSelectorThemeData[] = [
    {
        lightTheme: appThemeMain.lightTheme,
        darkTheme: appThemeMain.darkTheme,
        name: 'Main',
    },
    {
        lightTheme: verintTheme.lightTheme,
        darkTheme: verintTheme.darkTheme,
        name: 'Verint',
    },
    {
        lightTheme: rainbowTheme.lightTheme,
        darkTheme: rainbowTheme.darkTheme,
        name: 'Rainbow',
    },
    {
        lightTheme: badContrastTheme.lightTheme,
        darkTheme: badContrastTheme.darkTheme,
        name: 'Bad Contrast',
    },
    {
        lightTheme: blackAndWhiteTheme.lightTheme,
        darkTheme: blackAndWhiteTheme.darkTheme,
        name: 'Black and White Theme',
    },
    {
        lightTheme: shadesTheme.lightTheme,
        darkTheme: shadesTheme.darkTheme,
        name: 'shades Theme',
    },
    {
        lightTheme: brushScriptTheme.lightTheme,
        darkTheme: brushScriptTheme.darkTheme,
        name: 'Brush Script Theme',
    },
    {
        lightTheme: CourierNewSriptTheme.lightTheme,
        darkTheme: CourierNewSriptTheme.darkTheme,
        name: 'Courier Script Theme',
    },
    {
        lightTheme: timesNewRomanScriptTheme.lightTheme,
        darkTheme: timesNewRomanScriptTheme.darkTheme,
        name: 'Times New Roman Theme',
    },
    {
        lightTheme: adjustedTypeComfortableTheme.lightTheme,
        darkTheme: adjustedTypeComfortableTheme.darkTheme,
        name: 'Spaced Text Theme',
    },
    {
        lightTheme: adjustedTypeCompressionTheme.lightTheme,
        darkTheme: adjustedTypeCompressionTheme.darkTheme,
        name: 'Compressed Text Theme',
    },
    {
        lightTheme: customShapeTheme.lightTheme,
        darkTheme: customShapeTheme.darkTheme,
        name: 'Custom Shape Theme',
    },
    {
        lightTheme: everythingIsRoundedTheme.lightTheme,
        darkTheme: everythingIsRoundedTheme.darkTheme,
        name: 'rounded corners Theme',
    },
    {
        lightTheme: everythingIsSharpTheme.lightTheme,
        darkTheme: everythingIsSharpTheme.darkTheme,
        name: 'sharp corners Theme',
    },
];

interface AlmeThemeSelectorProps {
    setTheme: (theme: AlmeTheme) => void;
}

interface ThemeSelectorState {
    themeNumber: number;
    name: string;
}

export default function AlmeThemeSelector(props: AlmeThemeSelectorProps): ReactElement {
    const [state, setState] = useState<ThemeSelectorState>({
        themeNumber: 0,
        name: appThemes[0].name,
    });

    const handleChange = (name: keyof typeof state) => (
        event: React.ChangeEvent<{ value: unknown }>,
    ): void => {
        setState({
            ...state,
            [name]: event.target.value,
        });
        if (name === 'themeNumber') {
            const lightTheme = appThemes[event.target.value as number].lightTheme;
            const darkTheme = appThemes[event.target.value as number].darkTheme;
            const theme = {
                lightTheme: lightTheme,
                darkTheme: darkTheme,
            } as AlmeTheme;

            props.setTheme(theme);
        } else {
            const currentTheme: ThemeSelectorThemeData = appThemes.find((value) => {
                return value.name === event.target.value as string;
            }) || appThemes[0];

            const theme = {
                lightTheme: currentTheme.lightTheme,
                darkTheme: currentTheme.darkTheme,
            } as AlmeTheme;

            props.setTheme(theme);
        }
    };

    return (
        <FormControl >
            <InputLabel
                htmlFor="alme-theme-select">Theme</InputLabel>
            <NativeSelect
                id='alme-theme-select'
                value={state.themeNumber}
                onChange={handleChange('themeNumber')}
                inputProps={{
                    name: 'themeNumber',
                }}
            >
                {
                    appThemes.map((value, index) => {
                        return (
                            <option
                                value={index}
                                key={index}
                            >
                                {value.name}
                            </option>
                        );
                    })
                }
            </NativeSelect>
        </FormControl>
    );
}